/** True for a turn the agent should also read in English: spoken in another language. */
export function isOtherLanguage(code: string | undefined): boolean {
  return !!code && !code.toLowerCase().startsWith('en');
}

/**
 * True when the text itself needs an English rendering: it contains letters
 * from a script other than Latin. On a Hindi call the caller still says
 * "Hello", a booking number or an email address — those are already readable,
 * and labelling them "Hindi · translation not available" is noise.
 */
export function needsEnglish(text: string | undefined): boolean {
  return !!text && /[^\p{Script=Latin}\p{Script=Common}\p{Script=Inherited}]/u.test(text);
}

/** "mr-IN" → "Marathi". Falls back to the code itself where the browser cannot name it. */
export function languageName(code: string | undefined): string {
  if (!code) return '';
  try {
    const names = new Intl.DisplayNames(['en'], { type: 'language' });
    return names.of(code.split('-')[0]) || code;
  } catch {
    return code;
  }
}
